<template>
  <div class="withdraw-record">
    <div v-if="summary.unpaid_amount && summary.unpaid_amount !== 0" class="summary-section" style="margin-bottom: 20px; padding: 15px;">
      <div style="margin-bottom: 10px; color: #1D3A71; font-size: 24px;font-weight: 600">{{ $t('merchantAccount.nsds_bill_summary') }}</div>
      <el-form label-position="left" label-width="400px">
        <el-form-item class="height-16 nsds-text-1" :label="$t('merchantAccount.amount_used') + ':'">
          <span>{{ summary.unpaid_amount | toDivideWithDot }}</span>
        </el-form-item>
        <el-form-item class="height-16 nsds-text-1" :label="$t('merchantAccount.service_fee') + ':'">
          <span>{{ summary.unpaid_fee_amount | toDivideWithDot }}</span>
        </el-form-item>
        <el-form-item class="height-16 nsds-text-2" :label="$t('merchantAccount.discount') + ':'">
          <span>{{ summary.fee_exempt_amount | toDivideWithDot }}
            <el-tooltip placement="top">
              <div slot="content" style="width: 300px">
                <span>{{ $t('merchantAccount.discount_tip_1') + ' ' + summary.repay_time + ' ' + $t('merchantAccount.discount_tip_2') }}</span>
              </div>
              <span> <svg-icon icon-class="icon-font-question" class="icon-question" /></span>
            </el-tooltip>
          </span>
        </el-form-item>
        <div class="line" />
        <span style="display: flex">
          <el-form-item class="height-16 nsds-text-2" :label="$t('merchantAccount.total') + ':'">
            <span class="go-to-pay"> {{ summary.total_amount | toDivideWithDot }}</span>
          </el-form-item>
          <el-button style="margin-left: 60px" type="primary" size="small" @click="goToPay(summary)">{{ $t('merchantAccount.go_to_pay') }}</el-button>
        </span>
      </el-form>
    </div>
    <div class="filter-container">
      <span class="transTime">{{ $t('components.date') }}:</span>
      <el-date-picker
        v-model="search.times"
        size="small"
        class="mb-10 picker"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        type="daterange"
        range-separator="~"
        :start-placeholder="$t('components.start_date')"
        :end-placeholder="$t('components.end_date')"
      />
      <!-- 查询 -->
      <el-button class="search-btn mb-10" size="small" type="primary" icon="el-icon-search" @click="getMchWithdrawInfo">{{ $t('components.search') }}</el-button>
      <!-- 明细excel下载 -->
      <el-button size="small" class="mb-24 download-btn" type="info" :disabled="downloading" icon="el-icon-download" @click="onClickDowmloadBtn">{{ $t('components.download') }}</el-button>
    </div>
    <div class="tableContainer">
      <!-- 列表 -->
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
      >

        <el-table-column :label="$t('merchantAccount.bill_date')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.bill_date }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.currency')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.currency }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.nsds_usage_date')" align="center" min-width="110px">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_date_end }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.nsds_usage_amount')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.used_amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.nsds_service_fee')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.fee_amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.billing_type')" align="center">
          <template slot-scope="scope">
            <span>{{ getBillingTypeMap(scope.row.fee_dimension).label }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.bill_total_amount')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.bill_total_amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.paid_amount')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.bill_paid_amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.pending_amount')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.bill_unpaid_amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.bill_status')" align="center">
          <template slot-scope="scope">
            <span>{{ NSDSBillStatusMap(scope.row.repay_status).label }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.settlement_date')" align="center" min-width="110px">
          <template slot-scope="scope">
            <span>{{ scope.row.repay_date }}</span>
          </template>
        </el-table-column>

      </el-table>

      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
      </div>
    </div>
    <RepaymentDetailsDialog
      ref="repaymentDetailsDialog"
      :visible.sync="repaymentDialogVisible"
      @getMchWithdrawInfo="getMchWithdrawInfo"
    />
  </div>
</template>

<script>

import {
  fetchMchWithdrawInfoAllList, fileDownloadNsdsBillPage,
  nsdsBillPage,
  preCalculate
} from '@/api/settlement/settlement'
import serviceConst from '@/const/serviceConst.json'
import { exportXlsx, filterEmptyAttr } from '@/utils/common'
import { appointDate } from '@/utils/index.js'
import { NSDSBillStatusMap } from '@/maps/status'
import RepaymentDetailsDialog from './RepaymentDetailsDialog.vue'
import { billingTypeMap } from '@/utils/maps'

export default {
  name: 'Withdraw_Record',
  components: {
    Paginator: () => import('@/views/components/Paginator'),
    RepaymentDetailsDialog
  },
  data() {
    return {
      search: {
        disburse_status: null, // 交易状态
        times: [appointDate(-3), appointDate()],
        blank: ''
      },
      tableData: [],
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      downloading: false,
      summary: {
        unpaid_amount: 0,
        unpaid_fee_amount: 0,
        fee_exempt_amount: 0,
        total_amount: 0,
        repay_time: null
      },
      repaymentDialogVisible: false
    }
  },
  computed: {
    NSDSBillStatusMap() {
      return function(value) {
        return NSDSBillStatusMap(value)
      }
    },
    getBillingTypeMap() {
      return function(value) {
        return billingTypeMap(value)
      }
    }
  },
  created() {
    this.getMchWithdrawInfo()
    this.getPreCalculate()
  },
  methods: {
    getMchWithdrawInfo(otherParams = {}) {
      this.listLoading = true
      const params = this.getParams(otherParams)
      nsdsBillPage(params).then(res => {
        if (res.code === serviceConst.resCode.succ) {
          if (!res.data) {
            return
          }
          const { total = 0, list = [] } = res.data
          this.listQuery.total = total
          this.listQuery.page = params.page ? params.page : 1
          this.tableData = list
        }
      }).finally(() => {
        this.listLoading = false
      })
    },

    getPreCalculate() {
      preCalculate().then(res => {
        if (res.code === serviceConst.resCode.succ) {
          this.summary = res.data || {}
        }
      }).finally(() => {
      })
    },

    getParams(otherParams = {}) {
      const { disburse_status, times = [] } = this.search
      let params = { bill_date_start: times && times[0], bill_date_end: times && times[1], disburse_status, ...otherParams }
      params = filterEmptyAttr(params)
      return params
    },

    handleFilter(otherParams = {}) {
      const params = this.getParams(otherParams)
      this.getMchWithdrawInfo(params)
    },

    onClickDowmloadBtn() {
      const params = this.getParams()
      this.downloading = true
      params.page = 0
      fileDownloadNsdsBillPage(params).then(res => {
        if (res.code === serviceConst.resCode.succ) {
          if (res.data.is_async) {
            this.$store.commit('app/SET_SHOW_DOWNLOAD_LIST', true)
          }
        }
      }).finally(() => {
        setTimeout(() => {
          this.downloading = false
        }, 3000)
      })
    },

    handleXlsxData(data = []) {
      const rows = [[
        this.$t('merchantAccount.bill_date'),
        this.$t('data.currency'),
        this.$t('merchantAccount.nsds_usage_date'),
        this.$t('merchantAccount.nsds_usage_amount'),
        this.$t('merchantAccount.nsds_service_fee'),
        this.$t('merchantAccount.billing_type'),
        this.$t('merchantAccount.bill_total_amount'),
        this.$t('merchantAccount.paid_amount'),
        this.$t('merchantAccount.pending_amount'),
        this.$t('merchantAccount.bill_status')
      ]]

      if (Array.isArray(data) && data.length > 0) {
        data.forEach((tr) => {
          rows.push([
            tr.bill_date,
            tr.currency,
            tr.transaction_date_end,
            tr.used_amount,
            tr.fee_amount,
            tr.fee_dimension,
            tr.bill_total_amount,
            tr.bill_paid_amount,
            tr.bill_unpaid_amount,
            this.NSDSBillStatusMap(tr.repay_status).label
          ])
        })
      }
      return Promise.resolve(rows)
    },
    onClickPaginator() {
      this.getMchWithdrawInfo(this.listQuery)
    },
    goToPay(row) {
      this.$refs.repaymentDetailsDialog.changModalStatus(true, row)
    }
  }
}
</script>

<style lang="scss" scoped>
.withdraw-record{
  background-color: #fff;
   .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Inter-Medium';
    color: #606266;
  }
  .filter-container{
    margin-top: 14px;
    margin-bottom: 32px;
    text-align: right;
  }
  .search-frame {
    width: 160px;
    margin-right: 5px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .picker{
    margin-right: 5px;
  }
  .status{
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
 .mb-10{
    margin-bottom: 10px;
  }
}
.line{
  display: inline-block;
  margin:12px 0;
  width: 560px;
  height: 1px;
  background:#D3D7DF;
  vertical-align: -4px;
}
.height-16{
  height: 16px;
}
.nsds-text-1{
  color: #1D3A71;
  font-size: 14px;
  font-weight: 500;
}
.nsds-text-2{
  color: #1D3A71;
  font-size: 14px;
  font-weight: 400;
}
.go-to-pay{
  min-width: 200px;
}
.icon-question{
  font-size: 11px;
  position: relative;
  top: -2px;
  cursor: pointer;
}
</style>
